import * as types from "../constants/actionTypes";
import { getCurrencies } from "../api/currencies";
import { generateAsyncAction } from "./generateAsyncAction";

export const setCurrency = currency => dispatch => {
  dispatch({
    type: types.SET_CURRENCY,
    payload: currency
  });
};

export const getCurrenciesList = () => async dispatch => {
  dispatch({ type: types.GET_CURRENCIES_REQUEST });
  const getCurrenciesAction = await generateAsyncAction({
    onFailAction: currenciesFailed,
    onSuccessAction: currenciesSuccess,
    asyncApiMethod: getCurrencies
  });
  return dispatch(getCurrenciesAction);
};

export const setCurrencies = list => dispatch => {
  dispatch({
    type: types.GET_CURRENCIES_SUCCESS,
    payload: list
  });
};

export const currenciesSuccess = ({ payload }) => dispatch => {
  dispatch({
    type: types.GET_CURRENCIES_SUCCESS,
    payload: payload
  });
};

const currenciesFailed = ({ message, title }) => ({
  type: types.GET_CURRENCIES_FAILED,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/currenciesActions.js